import { z } from 'zod';

/**
 * 利用者編集フォームの Zod スキーマ。
 * billableFrom は必須。
 *
 * 過去日付チェックは DatePickerFieldController（presentations 側）の
 * `fromDate={new Date()}` によるカレンダーUI上の選択不可制御のみで行う。
 * 編集フォームは既存レコード（過去日付のまま保存された billableFrom を持つ
 * ユーザーも実在する）を読み込むため、Zod 側にも過去日 refine を追加すると
 * 「値を変更していないのにフォームを開いただけでエラーになる」問題を避けるための
 * 追加ロジックが必要になり複雑化する。そのため本フォームでは UI 制御のみに統一する。
 */
export const editUserFormSchema = z.object({
  fullName: z.string().min(1, '氏名を入力してください'),
  email: z
    .string()
    .min(1, 'メールアドレスを入力してください')
    .email('有効なメールアドレスを入力してください'),
  branchId: z.string().optional(),
  billableFrom: z
    .date({ invalid_type_error: '利用開始日を選択してください。' })
    .nullable()
    .refine(v => v !== null, { message: '利用開始日を選択してください。' })
    .transform(v => v as Date),
});

export type EditUserFormValues = z.infer<typeof editUserFormSchema>;
